// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
  
  .popup-content {
    background: #fff;
    padding: 20px 30px;
    border-radius: 10px;
    width: 400px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .popup-actions {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  
  .btn-cancel,
  .btn-delete {
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    font-weight: bold;
  }
  
  .btn-cancel {
    background: #ddd;
    color: #333;
  }
  
  .btn-delete {
    background: #e63946;
    color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/ProfileButton/ConfirmDeletePopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;;EAEA;;IAEE,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb","sourcesContent":[".popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n  }\n  \n  .popup-content {\n    background: #fff;\n    padding: 20px 30px;\n    border-radius: 10px;\n    width: 400px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .popup-actions {\n    margin-top: 20px;\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .btn-cancel,\n  .btn-delete {\n    padding: 8px 16px;\n    border: none;\n    cursor: pointer;\n    font-weight: bold;\n  }\n  \n  .btn-cancel {\n    background: #ddd;\n    color: #333;\n  }\n  \n  .btn-delete {\n    background: #e63946;\n    color: #fff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
